import $ from 'jquery';
import Sortable from 'sortablejs';

export default class BlockSort {
  constructor(sortableInit, sortOptions) {
    this.sortableInit = sortableInit;
    this.sortOptions = {
      animation: 200,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      handle: '.js__sort-handler',
      onUpdate: event => {
        this.updateInputs(event.target);
      },
      ...sortOptions,
    };

    if ($(this.sortableInit).length) {
      this.updateInputs($(sortableInit));
      this.init();
    }
  }

  updateInputs(node) {
    $(node)
      .children()
      .each((index, item) => $(item).find('input[type="number"]').val(index));
  }

  init() {
    this.sortable = new Sortable($(this.sortableInit).get(0), this.sortOptions);
    $('.js__image-add-button').on('click', () => {
      setTimeout(() => {
        this.updateInputs($('.js__product-images-sort-init'));
      }, 0);
    });
  }
}
